import React from 'react';
import { useSelector } from 'react-redux';

// components
import { YesNo, TextInput } from '../components/inputs';
import { FormRow } from '../components/layout';
import { Collapse } from '../../../common/components';

/* eslint-disable */
function POA() {
  const { ispoa } = useSelector(store => store.values);

  return (
    <div>
      <FormRow>
        <YesNo
          label="Are you a Power of Attorney enrolling on behalf of the applicant?"
          name="ispoa"
          unsetFieldsOnFalse={[
            'poa_fname',
            'poa_lname',
            'poa_addr_street1',
            'poa_addr_street2',
            'poa_addr_city',
            'poa_addr_state',
            'poa_addr_zip',
            'poa_tel',
            'poa_rel',
          ]}
        />
      </FormRow>
      <Collapse recalculateHeightOnChange={ispoa} isOpen={ispoa}>
        <FormRow>
          <TextInput
            autoFocus
            cols="6"
            label="First Name"
            name="poa_fname"
            className="mb-3"
          />
          <TextInput
            cols="6"
            label="Last Name"
            name="poa_lname"
            className="mb-3"
          />
          <TextInput
            label="Street address 1"
            name="poa_addr_street1"
            className="mb-3"
          />
          <TextInput
            label="Street address 2"
            name="poa_addr_street2"
            className="mb-3"
          />
          <TextInput
            autoFocus
            cols="6"
            label="City"
            name="poa_addr_city"
            className="mb-3"
          />
          <TextInput
            cols="6"
            label="State"
            name="poa_addr_state"
            className="mb-3"
          />
          <TextInput
            autoFocus
            cols="6"
            label="Zip code"
            name="poa_addr_zip"
            className="mb-3"
          />
          <TextInput
            cols="6"
            label="Phone Number"
            name="poa_tel"
            className="mb-3"
          />
          <TextInput
            cols="6"
            label="Relationship to applicant"
            name="poa_rel"
            className="mb-3"
          />
        </FormRow>
      </Collapse>
    </div>
  );
}

export default POA;
